import { createCustomerValidationForm } from '../../utils/validationSchema';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import CustomerForm from './CustomerForm';
import Form from '../../layouts/Form';

const EditCustomer = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  console.log(data)
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createCustomerValidationForm),
    defaultValues: async () => {
      return {
        full_name: data?.full_name,
        address: data?.address,
        vat_pan: data?.vat_pan,
        mobile_number: data?.primary_contact ? data?.primary_contact.slice(4) : null,
        secondary_contact: data?.secondary_contact ? data?.secondary_contact.slice(4) : null,
      }
    }
  });
  console.log(errors)
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
      />
    </Form>
  )
}

export default EditCustomer
